import React, { useState } from "react";
import { Card } from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import EditClient from "./EditClient";
import SearchField from "../../layouts/SearchField";
import {
  pageSelector,
  pageSizeSelector,
  resetSurvey,
} from "../../../redux/surveySlice";
import Table from "../../layouts/Table";
import AddNewClient from "./AddNewClient";
import { useDispatch, useSelector } from "react-redux";
import { resetClient, setClient } from "../../../redux/clientSlice";
import { resetUser } from "../../../redux/userSlice";

import {
  closeClientModal,
  modalSelector,
  openClientModal,
} from "../../../redux/modalSlice";
import { api } from "../../../services/api-service";

import RemoveClient from "./RemoveClient";
import { success } from "../../../redux/notificationSlice";
import axios from "axios";
import fileDownload from "js-file-download";
const ClientsList = ({ text, setSearchText, clients, getClients }) => {
  const dispatch = useDispatch();
  const { modal } = useSelector(modalSelector);
  const pageNumb = useSelector(pageSelector);
  const pageSize = useSelector(pageSizeSelector);
  const [selected, setSelected] = useState(false);

  const [modalShow, setModalShow] = React.useState(false);
  const headers = [
    {
      Header: () => (
        <span className="ctadocs">
          <Icon icon="fluent:document-bullet-list-20-regular" />
        </span>
      ),
      accessor: "authorityLetter",
      disableSortBy: true,
      Cell: (props) => {
        return props.row.original.authorityLetter ? (
          <Link
            className="ctadocs"
            to="#"
            onClick={() =>
              handleDownload(
                props.row.original.authorityLetter,
                props.row.original.authorityLetter.split("_")[1]
              )
            }
          >
            <Icon icon="carbon:document-download" />
          </Link>
        ) : (
          <></>
        );
      },
    },
    {
      Header: () => <span>Reference</span>,
      accessor: "clientRef",
      Cell: (props) => {
        return <p className="ref">{props.row.original.clientRef}</p>;
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: (props) => {
        return <p className="name">{props.row.original.name}</p>;
      },
    },
    {
      Header: "Address",
      accessor: "address",
      Cell: (props) => {
        return <p className="address">{props.row.original.address}</p>;
      },
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: " ",
      accessor: "edit",
      Cell: (props) => {
        return (
          <ul className="actionTable">
            <li>
              <Link
                to="#"
                className="edit"
                onClick={() => handleDelete(props.row.original)}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.8833 6.3125C12.8833 6.3125 12.5213 10.8025 12.3113 12.6938C12.2113 13.5972 11.6533 14.1265 10.7393 14.1432C8.99994 14.1745 7.25861 14.1765 5.51994 14.1398C4.64061 14.1218 4.09194 13.5858 3.99394 12.6985C3.78261 10.7905 3.42261 6.3125 3.42261 6.3125"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M13.8055 4.15999H2.50012"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M11.627 4.15998C11.1037 4.15998 10.653 3.78998 10.5503 3.27732L10.3883 2.46665C10.2883 2.09265 9.94968 1.83398 9.56368 1.83398H6.74168C6.35568 1.83398 6.01701 2.09265 5.91701 2.46665L5.75501 3.27732C5.65234 3.78998 5.20168 4.15998 4.67834 4.15998"
                    stroke="#A2A9B0"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </li>
            <li>
              <Link
                to="#"
                className="edit"
                onClick={() => {
                  dispatch(openClientModal());
                  dispatch(setClient(props.row.original));
                }}
              >
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.31805 13.1403C3.91266 13.1403 3.53385 13.0007 3.26137 12.7415C2.91579 12.4159 2.74965 11.9241 2.80946 11.3924L3.05535 9.2392C3.10187 8.83381 3.34777 8.2955 3.63354 8.00309L9.08971 2.22792C10.4521 0.785786 11.8743 0.745911 13.3164 2.10829C14.7586 3.47068 14.7984 4.89287 13.436 6.335L7.97987 12.1102C7.70075 12.4092 7.18238 12.6884 6.77698 12.7548L4.63705 13.1203C4.52407 13.127 4.42438 13.1403 4.31805 13.1403ZM11.223 2.10165C10.7113 2.10165 10.266 2.42064 9.8141 2.89914L4.35792 8.68096C4.22501 8.82052 4.07216 9.15281 4.04557 9.34554L3.79968 11.4988C3.7731 11.7181 3.82626 11.8975 3.94589 12.0105C4.06551 12.1235 4.24495 12.1633 4.46426 12.1301L6.60419 11.7646C6.79692 11.7314 7.11592 11.5586 7.24883 11.419L12.705 5.64384C13.5291 4.7666 13.8281 3.95582 12.6253 2.82604C12.0936 2.31431 11.635 2.10165 11.223 2.10165Z"
                    fill="#7E92A2"
                  />
                  <path
                    d="M12.1601 7.44485C12.1468 7.44485 12.1268 7.44485 12.1135 7.44485C10.0401 7.23883 8.37197 5.66378 8.05297 3.60359C8.0131 3.33112 8.19918 3.07858 8.47165 3.03206C8.74413 2.99218 8.99667 3.17826 9.04319 3.45074C9.29573 5.05902 10.5983 6.29513 12.2199 6.45463C12.4923 6.48121 12.6917 6.7271 12.6651 6.99958C12.6319 7.25212 12.4126 7.44485 12.1601 7.44485Z"
                    fill="#7E92A2"
                  />
                  <path
                    d="M14.5924 15.2869H2.63002C2.35755 15.2869 2.13159 15.0609 2.13159 14.7884C2.13159 14.5159 2.35755 14.29 2.63002 14.29H14.5924C14.8649 14.29 15.0908 14.5159 15.0908 14.7884C15.0908 15.0609 14.8649 15.2869 14.5924 15.2869Z"
                    fill="#7E92A2"
                  />
                </svg>
              </Link>
            </li>
          </ul>
        );
      },
    },
  ];

  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  const handleDelete = async (client) => {
    setSelected(client);
    const response = await api.get(`get-surveys?clientRef=${client.clientRef}`);
    if (response?.ok) {
      if (response.data.data.data.length > 0) {
        setModalShow(true);
      } else {
        onDelete(client);
      }
    }
  };

  const onDelete = async (client) => {
    const response = await api.delete(`delete-client/${client.id}`);
    if (response && response.ok) {
      setModalShow(false);
      dispatch(success({ message: "Client deleted successfully" }));
      let page =
        clients?.data.length === 1
          ? pageNumb > 1
            ? pageNumb - 1
            : pageNumb
          : pageNumb;
      dispatch(getClients(pageSize, page));
    }
  };

  return (
    <>
      <Tab.Container id="left-tabs-example" defaultActiveKey="second">
        <Card className="card-main p-0 ">
          <Card.Title className="mb-0 cstTitle align-items-center">
            <h5 className="mb-0">List of Clients</h5>
            {/*  <div className="col-lg-6">
              <div className="filterSearch">
                <div className="flex-1"></div>
                <SearchField onChange={setSearchText} text={text} />
              =  <BtnGroup
                  classes="btn cta-group cta-primary"
                  btnText="Add new"
                  icon={<Icon icon="ant-design:plus-outlined" />}
                />
               =
                <button
                  className="btn cta-primary cta-group"
                  onClick={() => openModal()}
                >
                  <span>Add New</span>
                  <i>
                    <Icon icon="ant-design:plus-outlined" />
                  </i>
                </button> 
              </div>
            </div>*/}
          </Card.Title>
          <Card.Body>
            <div className="clientFields">
              {clients.data && (
                <Table
                  headers={headers}
                  totalCount={clients.count}
                  isSearchAble={true}
                  searchText={text}
                  gridData={clients.data}
                  pageSize={20}
                  getData={getClients}
                  selected="No client added"
                  content="It seems like you have not added any client yet! Add one and view the content here."
                  addNew="Add new client"
                  onAdd={() => {
                    dispatch(resetClient());
                    dispatch(openClientModal());
                  }}
                />
              )}
            </div>
          </Card.Body>
        </Card>
      </Tab.Container>
      <AddNewClient
        show={modal.clientModal}
        getClients={getClients}
        onHide={() => {
          dispatch(closeClientModal());
        }}
      />

      <RemoveClient
        show={modalShow}
        type="Client"
        details="There are surveys associated with this client. Are you sure you want to remove it?"
        onHide={() => setModalShow(false)}
        onDelete={() => onDelete(selected)}
      />
    </>
  );
};

export default ClientsList;
